import Vue from 'vue';

Vue.component('show-daily-sales-legacy', () =>
    import(/* webpackChunkName: 'daily-sales-legacy-show' */ './show-daily-sales-legacy.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/daily-sales-legacy/index.js